import {
    saveAccessTokenToCookie,
    saveUsrIdToCookie,
    saveEmailToCookie,
    getAccessTokenFromCookie,
    getUsrIdFromCookie,
    getEmailFromCookie,
} from '@/utils/cookies';
import { registerUser, loginUser } from '@/api/auth';
import store from '../index'

const state = {
    accessToken: getAccessTokenFromCookie() || '',
    usrId: getUsrIdFromCookie() || '',
    email: getEmailFromCookie() || '',
};

const getters = {
    isLogin(state) {
        return state.email !== '';
    },
    getUsrId() {
        return state.usrId;
    }
};

const mutations = {
    setAccessToken(state, token) {
        state.accessToken = token;
    },
    setUsrId(state, usrId) {
        state.usrId = usrId;
    },
    setEmail(state, email) {
        state.email = email;
    },
    clearAccessToken(state) {
        state.accessToken = '';
    },
    clearUsrId(state) {
        state.usrId = '';
    },
    clearEmail(state) {
        state.email = '';
    },
};

const actions = {
    async SIGNUP({ commit }, userData) {
        const { data } = await registerUser(userData);
    },
    async LOGIN(commit, userData) {
        const response = await loginUser(userData);
        if(response.data.resultCode === 1) {
            store.commit('setAccessToken', response.data.data.accessToken);
            store.commit('setUsrId', response.data.data.usrId);
            store.commit('setEmail', response.data.data.email);
            saveAccessTokenToCookie(response.data.data.accessToken);
            saveUsrIdToCookie(response.data.data.usrId);
            saveEmailToCookie(response.data.data.email);
        }
        return response.data;
    },
};

export default {
	state,
	getters,
	mutations,
    actions
};